<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
    <path fill="currentColor" d="M13 4H6v16h12V9h-5z" opacity=".2"></path>
    <path
      fill="currentColor"
      d="m20 8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2zm-2 12H6V4h7v5h5z"
    ></path>
  </svg>
</template>

<script lang="ts">
export default {
  name: "IcTwotoneInsertDriveFile",
};
</script>
